import React from "react";
import spinner from "../../../Theming/gifs/spinner.gif";
import { withTranslation } from "react-i18next";
import "./index.css";
const ModalLoader = ({
  label,
  t
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-loader",
    "aria-busy": "true",
    "aria-live": "polite"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-loader__container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "modal-loader__img",
    src: spinner
  }), /*#__PURE__*/React.createElement("h2", {
    className: "modal-loader__heading",
    role: "alert",
    "aria-busy": "true"
  }, label || t("ModalLoading"))));
};
export default withTranslation()(ModalLoader);